/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Home_BadgeInputs */

const en_site_home_badge = /** @type {(inputs: Site_Home_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NEW`)
};

const id_site_home_badge = /** @type {(inputs: Site_Home_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BARU`)
};

/**
* | output |
* | --- |
* | "NEW" |
*
* @param {Site_Home_BadgeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_home_badge = /** @type {((inputs?: Site_Home_BadgeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Home_BadgeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_home_badge(inputs)
	return en_site_home_badge(inputs)
});